module.exports = __webpack_public_path__ + "img/bgc2.a2e8a710.png";